import { useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'
import Tooltip from 'components/Shared/Tooltip/Index'

const StyledToggleSwitch = styled.label`
  display: flex;
  margin-bottom: 0;
`

const StyledSwitch = styled.label`
  position: relative;
  margin-left: 0;
  margin-bottom: 0;
  display: inline-block;
  width: 24px;
  height: 13px;
  input {
    display: none;
  }
`

const StyledSlider = styled.span`
  position: absolute;
  cursor: ${props => props.disabled ? 'initial' : 'pointer'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.disabled ? '#FFFFFF' : colors.secondary70};
  transition: .4s;
  border: 1px solid ${colors.secondary70};
  border-radius: 13px;

  &:before {
    position: absolute;
    content: "";
    height: ${props => props.disabled ? 7 : 9}px;
    width: ${props => props.disabled ? 7 : 9}px;
    background-color: #FFFFFF;
    transition: .4s;
    bottom: ${props => props.disabled ? 1 : 0}px;
    right: ${props => props.disabled ? 12 : 11}px;
    border-radius: 50%;
    background: #FFFFFF;
    border: 1px solid ${colors.secondary70};
    transform: translateX(0px);
  }
`

const StyledCheckbox = styled.input`
  &:checked + ${StyledSlider} {
    background-color: ${props => props.disabled ? 'transparent' : colors.primary40};
    border: 1px solid ${props => props.disabled ? colors.secondary70 : colors.primary40};
    &:before {
      transform: translateX(11px);
      border: 1px solid ${props => props.disabled ? colors.secondary70 : colors.primary40};
    }
  }
`

const ToggleSwitch = ({ value, onChange, className, disabled, tooltip, tooltipId }) => {
  const checkboxInputRef = useRef(null)
  const onKeyDown = (e) => {
    if ([' ', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      checkboxInputRef.current.click()
      e.preventDefault()
    }
  }

  return (
    <StyledToggleSwitch
      className={className}
      data-test='toggle-switch'
      data-tooltip-content={tooltip}
      data-tooltip-id={tooltipId}
      tabIndex='0'
      onKeyDown={onKeyDown}
    >
      <StyledSwitch>
        <StyledCheckbox
          disabled={disabled}
          value={value || false}
          checked={value || false}
          onChange={(e) => { onChange?.(e) }}
          type='checkbox'
          ref={checkboxInputRef}
        />
        <StyledSlider disabled={disabled} />
      </StyledSwitch>
      <Tooltip id={tooltipId} />
    </StyledToggleSwitch>
  )
}

ToggleSwitch.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipId: PropTypes.string,
  tooltip: PropTypes.string,
}

export default ToggleSwitch
